export function set(object: Record<any, any>, path: string | Array<string>, value: any) {
  const pathArray = Array.isArray(path) ? path : path.split(/[,[\].]+?/).filter(Boolean)
  let current = object

  pathArray.forEach((key, index) => {
    // If we're at the last key, set the value.
    if (index === pathArray.length - 1) {
      current[key] = value
      return
    }

    // Check if the next key in the path is numeric (indicating an array index).
    const isNextIndexNumeric = /^\d+$/.test(pathArray[index + 1])
    // Ensure the current key points to an object. If not, or if it's an array when it shouldn't be
    // (or vice versa), reset it to an object or an array based on the next key.
    if (
      !current[key] || // current[key] is not set
      typeof current[key] !== 'object' || // current[key] is not an object
      Array.isArray(current[key]) !== isNextIndexNumeric // Misalignment between expected type (array or object)
    ) {
      current[key] = isNextIndexNumeric ? [] : {} // Set current[key] to an array or object based on the next key.
    }

    // Move deeper into the object for the next iteration.
    current = current[key]
  })

  return object
}
